import { FilterSection } from 'common-components/filter';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores/rematch/root-store';
import { useBookings } from '../books-view-context/bookings-view-context';
import { availableFiltersList, availableFiltersRoster, BookingsViewType } from './types';

interface BookingsViewToolbarFiltersProps {
  view: BookingsViewType;
}

export const BookingsViewToolbarFilters = ({ view }: BookingsViewToolbarFiltersProps) => {
  const displayTimezone = useBookings((selector) => selector.displayTimezone);
  const onChangeFilter = useBookings((selector) => selector.onChangeFilter);
  const bookingsFilter = useSelector((state: IRootState) => state.bookingsStore.bookingsFilter);

  return (
    <FilterSection
      availableFilters={view === 'list' ? availableFiltersList : availableFiltersRoster}
      filters={bookingsFilter}
      onChangeFilter={onChangeFilter}
      displayTimezone={displayTimezone ?? null}
      dateFilterV2
    />
  );
};
